import { Controller } from "@hotwired/stimulus"

// Shows the Überstundenabbau panel while the selected leave type is an
// overtime-deduction type. The select's option values are LeaveType ids, so
// the semantics come from the per-type data spans the form renders
// (data-overtime-deduction), never from the option value itself.
export default class extends Controller {
  connect() {
    this.monthly_overtime()
  }

  monthly_overtime() {
    const select = document.getElementById("leave_type")
    const panel = document.getElementById("my_overtime_calculation")

    if (!select || !panel) return

    const typeData = document.querySelector(`[data-leave-type-id="${CSS.escape(select.value)}"]`)
    const overtimeDeduction = typeData && typeData.dataset.overtimeDeduction === "true"
    panel.style.display = overtimeDeduction ? "block" : "none"
  }
}
